import { IPermissionsState } from "@/core/interfaces/permissionsState.interface";

const permissionsState: IPermissionsState = {
  permissions: [],
  permissionCategories: [],
  isFetchingPermission: false,
};

export default permissionsState;
